import { OnInit, Input, Optional, Inject } from '@angular/core';
import { Component } from '@angular/core';

@Component({
    selector: 'equipt-prelogin',
    templateUrl: './equipt-prelogin.component.html'
})
export class EquiptPrelogin implements OnInit {
   @Input() isLogin = false;
   @Input() isRegister = false;
   preloginEquiptUrl: string;
   preloginRegisterUrl: string;

    constructor(@Optional() @Inject('AppSettings') appSettings: any ) {
        if (appSettings.ibdConfigMap.preLoginEquiptUrl) {
            this.preloginEquiptUrl = appSettings.ibdConfigMap.preLoginEquiptUrl;
        }
        if (appSettings.ibdConfigMap.preLoginEquipRegistertUrl) {
            this.preloginRegisterUrl = appSettings.ibdConfigMap.preLoginEquipRegistertUrl;
        }
      }

      ngOnInit() {
      }
}
